"use client"

import { usePathname, useRouter } from "next/navigation"

export function useHashNavigation() {
  const router = useRouter()
  const pathname = usePathname()

  function navigateWithHash(href: string) {
    if (!href.startsWith("/#")) {
      router.push(href)
      return
    }

    const targetId = href.split("#")[1]
    const el = document.getElementById(targetId)

    // Se estamos na home
    if (pathname === "/") {
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" })
      }
      return
    }

    // Se estamos em outra página
    router.push("/#" + targetId)

    setTimeout(() => {
      const tryEl = document.getElementById(targetId)
      if (tryEl) {
        tryEl.scrollIntoView({ behavior: "smooth", block: "start" })
      }
    }, 300)
  }

  return navigateWithHash
}